import { useState } from 'react';
import PropTypes from 'prop-types';

import { useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import PlansContainer from '../PlansContainer/PlansContainer';

import { generalData } from 'constants/Preregister/generalData';

import classes from './Payment.module.css';

const Payment = props => {
  const [paymentPlans] = useState(props.selectedPlan);
  const prevalueData = {
    firstName: props.userInfo.nombre,
    lastName: props.userInfo.apellido,
    email: props.userInfo.email,
    program: props.program
  };

  const { register } = useForm({
    defaultValues: prevalueData
  });

  return (
    <div className={classes.container}>
      {generalData.map(input => (
        <TextField
          key={input.value}
          className={classes.textField}
          {...register(input.value)}
          placeholder={input.label}
          type="text"
          label={input.label}
          disabled={input.disabled}
        />
      ))}
      <TextField
        placeholder="Programa al que desea inscribirse"
        {...register('program')}
        className={classes.textField}
        label="Programa al que desea inscribirse"
        disabled
      />
      <PlansContainer paymentPlans={paymentPlans} selected />
      <div className={classes.btnContainer}>
        <Button
          compponent="a"
          target="_blank"
          href={`${process.env.REACT_APP_API_PATH_PAYMENT_URL}/${props.idOrder}`}
          className={classes.btnSend}
        >
          Pagar
        </Button>
      </div>
    </div>
  );
};

Payment.propTypes = {
  // eslint-disable-next-line react/require-default-props
  userInfo: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  program: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  reloadInfo: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  selectedPlan: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  idOrder: PropTypes.string
};

export default Payment;
